module.exports = __webpack_public_path__ + "static/media/c5.64390dd8.jpg";